// colors from Blast TV Design System
const canvas100 = "#1F0C19";
const canvas95 = "#2A1825";
const canvas90 = "#362431";
const canvas80 = "#4D3D48";
const neutral50 = "#8D858C";
const neutral20 = "#D2CED1";
const neutral10 = "#E9E7E8";
const neutral0 = "#FFFFFF";
const yellow = "#FFFE3E";
const red = "#F23F37";
const purple = "#9E4FF4";
const green = "#0CC76E";
const fall = "#FF7E55";
const spring = "#7CD0BD";
const final = "#FFC046";
const inherit = "inherit";
// for convenience
const white = neutral0;
// Mark as deprecated
/**
 * @deprecated Colors is no longer the source of truth for colors. Please use tailwindcss classes instead. Will be removed in future versions.
 */
export const colors = {
    white,
    canvas100,
    canvas95,
    canvas90,
    canvas80,
    neutral50,
    neutral20,
    neutral10,
    neutral0,
    yellow,
    red,
    purple,
    green,
    fall,
    spring,
    final,
    inherit,
};
//# sourceMappingURL=colors.js.map